export default {"src":"/_next/static/media/chevron_down.b21f5815.svg","height":7,"width":11,"blurWidth":0,"blurHeight":0};